import type { Tone } from "@/components/ds/Badge";

/**
 * Les statuts d'une offre, vus par l'ÉCOLE.
 *
 * Ce ne sont pas les mots de l'entreprise (`src/espace/labels.ts`) : elle lit l'effet
 * (« Reçue », l'école la relit), l'école lit ce qu'elle a à faire (« À traiter »).
 * Les clés, elles, sont les mêmes : un seul statut, deux lecteurs.
 */
export const OFFER_STATUS_ECOLE: Record<string, { label: string; tone: Tone }> = {
	nouveau: { label: "À traiter", tone: "warning" },
	a_completer: { label: "Complément demandé", tone: "warning" },
	validee: { label: "Publiée", tone: "success" },
	refusee: { label: "Non retenue", tone: "neutral" },
	archivee: { label: "Terminée", tone: "neutral" },
};

/** Une offre en attente se tranche : c'est la seule où publier et refuser ont un sens. */
export const A_TRAITER = ["nouveau", "a_completer"];

/** « 21 octobre 2026 », depuis un jour au format `AAAA-MM-JJ` sans décalage de fuseau. */
export function formatJour(jour: string): string {
	return new Date(`${jour}T12:00:00`).toLocaleDateString("fr-FR", {
		day: "numeric",
		month: "long",
		year: "numeric",
	});
}
